module.exports = __webpack_public_path__ + "assets/ojo_bemakoha_letras.4695a20d76828cf75fda1668fe2b2701.png";


//////////////////
// WEBPACK FOOTER
// ./img/ojo_bemakoha_letras.png
// module id = 872
// module chunks = 0